import { useMemo } from 'react';

export function useMicromags(initialMicromags) {
    // const { isKiosk = null } = useSite();
    const micromags = useMemo(() => {
        if (initialMicromags === null) {
            return null;
        }
        return initialMicromags;
    }, [initialMicromags]);

    return micromags;
}

export default useMicromags;
